import { Button, Snackbar } from '@mui/material'
import { NotificationsProvider } from '@toolpad/core/useNotifications';
import Alert from '@mui/material/Alert';

const AlertReload = ({ handleClick, open, mensagemAlert, corAlert }) => {

    return (
        <NotificationsProvider>
            <Snackbar open={open} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} onClose={handleClick}>
                <Alert
                    severity={corAlert ? 'success' : 'error'}
                    action={
                        <Button color="inherit" size="small" onClick={handleClick} >
                            OK
                        </Button>
                    }
                >
                    {mensagemAlert}
                </Alert>
            </Snackbar>
        </NotificationsProvider>
    );

}

export default AlertReload
